export default __webpack_public_path__ + "static/media/fhrabdm.553b7185.jpg";